import { LightBulbIcon } from '@heroicons/react/24/outline';

const Funding = () => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center text-center">
    <LightBulbIcon className="h-20 w-20 text-indigo-400 mb-6 animate-pulse" />
    <h1 className="text-4xl font-bold text-gray-900 dark:text-white mb-4">Funding Coming Soon</h1>
    <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 max-w-xl">
      We are working hard to bring you a new way to discover, support, and invest in innovative projects and startups. Stay tuned for updates!
    </p>
    <span className="inline-block px-4 py-2 bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 rounded-full text-sm font-medium">
      Launching later this year
                </span>
    </div>
  );

export default Funding; 